import React from 'react';
import PropTypes from 'prop-types';
import { ClapSpinner } from 'react-spinners-kit';
import * as Ui from './styles';

const propTypes = {
  running: PropTypes.bool,
  size: PropTypes.number,
};

const defaultProps = {
  size: 30,
  running: false,
};

export default function LoadingCircleAnalyze(props) {
  const { running, size } = props;

  return (
    <Ui.Loading running={running}>
      <ClapSpinner
        size={size}
        loading={running}
        frontColor="#FFF"
        backColor="#FFF"
      />
    </Ui.Loading>
  );
}

LoadingCircleAnalyze.propTypes = propTypes;
LoadingCircleAnalyze.defaultProps = defaultProps;
